<div>
  <table>
    @for (item of users; track item) {
      <tr>
        <td style="padding: 0px 10px 10px 0px">
          {{ item.firstName }} {{ item.lastName }}
        </td>
        <td style="padding: 0px 0px 10px 0px">
          <input type="button" value="Select" (click)="selectUser(item.id)" />
        </td>
      </tr>
    }
  </table>
</div>
